import Router from "@/common/router/Router";

export default class ModelRouter extends Router {
  static BASE_PATH = "/model";
  static SHOW_ROUTE_NAME = "model-show";
  static CREATE_ROUTE_NAME = "model-create";
  static UPDATE_ROUTE_NAME = "model-update";
  static LIST_ROUTE_NAME = "model-list";
  private static _instance: ModelRouter;
  public static instance(): ModelRouter {
    if (!ModelRouter._instance) {
      ModelRouter._instance = new ModelRouter();
    }
    return ModelRouter._instance;
  }

  private constructor() {
    super(
      ModelRouter.BASE_PATH,
      ModelRouter.SHOW_ROUTE_NAME,
      ModelRouter.CREATE_ROUTE_NAME,
      ModelRouter.UPDATE_ROUTE_NAME,
      ModelRouter.LIST_ROUTE_NAME
    );
  }
}
